import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DeleteLesson {
    isLoading: boolean;
    error: string | null;
    message: string | null;
    success: boolean;
}

const initialState: DeleteLesson = {
    message: null,
    isLoading: false,
    error: null,
    success: false,
};


const deleteLessonSlice = createSlice({
    name: 'deleteLesson',
    initialState,
    reducers: {
        setdeleteLesson: (state: DeleteLesson, action: PayloadAction<DeleteLesson>) => {
            state.message = action.payload.message;
            state.isLoading = false;
            state.error = null;
            state.success = true;
        },
        setloading: (state: DeleteLesson, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            state.error = null;
            state.success = false;
        },
        seterror: (state: DeleteLesson, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
            state.success = false;
        },
        resetdeleteLesson: () => {
            return initialState;
        },
    },
});

export const { setdeleteLesson, setloading, seterror, resetdeleteLesson } = deleteLessonSlice.actions;

export default deleteLessonSlice.reducer;
